import React from 'react';

import { useCompanyRegionExposure } from '~/hooks/use-knowledge-graph/useKnowledgeGraph';

import { GeographicExposureTable } from '../components/GeographicExposureTable';
import { useGeographicDrawer } from '../drawers/useGeographicDrawer';

export interface RegionalExposureTabProps {
  entityTag: string;
}

export const RegionalExposureTab = ({
  entityTag,
}: RegionalExposureTabProps) => {
  const { openRegion } = useGeographicDrawer();

  const { data, isFetching } = useCompanyRegionExposure({
    entityTag: entityTag,
    enabled: !!entityTag,
  });

  return (
    <GeographicExposureTable
      mode="region"
      data={data}
      isFetching={isFetching}
      onRowClick={openRegion}
    />
  );
};
